import React from 'react';
import { Link } from 'react-router-dom';
import { UserCircleIcon, StarIcon } from '@heroicons/react/24/solid';

interface Artist {
  id: number;
  name: string;
  genre: string;
  score: number;
  avatar: string;
}

interface ArtistCardProps {
  artist: Artist;
}

const ArtistCard: React.FC<ArtistCardProps> = ({ artist }) => {
  // Berechne die Hintergrundfarbe basierend auf dem Score
  const getScoreColor = (score: number) => {
    if (score >= 80) return 'bg-green-500';
    if (score >= 60) return 'bg-green-400';
    if (score >= 40) return 'bg-yellow-400';
    if (score >= 20) return 'bg-orange-400';
    return 'bg-red-400';
  };

  return (
    <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
      <div className="p-4">
        <div className="flex items-center space-x-4">
          {artist.avatar ? (
            <img 
              src={artist.avatar} 
              alt={artist.name} 
              className="h-12 w-12 rounded-full object-cover"
            />
          ) : (
            <UserCircleIcon className="h-12 w-12 text-gray-400" />
          )}
          
          <div className="flex-1 min-w-0">
            <Link to={`/artist/${artist.id}`} className="block">
              <p className="text-sm font-medium text-gray-900 truncate">{artist.name}</p>
              <p className="text-sm text-gray-500 truncate">{artist.genre}</p>
            </Link>
          </div>
          
          <div className="flex flex-col items-center">
            <div className={`${getScoreColor(artist.score)} text-white text-sm font-bold rounded-full h-10 w-10 flex items-center justify-center`}>
              {artist.score}
            </div>
            <span className="text-xs text-gray-500 mt-1">Score</span>
          </div>
        </div>
      </div>
      
      <div className="border-t border-gray-200 bg-gray-50 px-4 py-3 flex justify-between">
        <Link 
          to={`/artist/${artist.id}`} 
          className="text-xs font-medium text-green-600 hover:text-green-700"
        >
          Details anzeigen
        </Link>
        
        <button className="text-xs text-gray-500 hover:text-yellow-500 flex items-center">
          <StarIcon className="h-4 w-4 mr-1" />
          Favorisieren
        </button>
      </div>
    </div>
  );
};

export default ArtistCard;